import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components'

export const StyledPregnancyNavigation = styled.div`
  ${MediaQueries.mbDown} {
    display: none;
  }
  max-width: fit-content;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  gap: 24px;
  width: 100%;
  min-width: 400px;
  background: ${theme?.colors.neutral50};
  border-radius: 8px;
  .category-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 12px;
  }
`

export const StyledCategory = styled.a`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  gap: 16px;
  min-height: 64px;
  background: #ffffff;
  border-radius: 8px;
  .category-image {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: ${theme?.colors.neutral50};
    border-radius: 50%;
    overflow: hidden;
    img {
      object-fit: cover;
    }
  }
`
